import { render, staticRenderFns } from "./addUnit.vue?vue&type=template&id=b280bd7c"
import script from "./addUnit.vue?vue&type=script&lang=js"
export * from "./addUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports